import { ChevronDown } from "lucide-react";

export function Section({ icon: Icon, iconColor = "text-cyan-400", title, open, onToggle, testid, children }) {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden" data-testid={testid}>
      <button type="button" onClick={onToggle} data-testid={`${testid}-header`}
        className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-slate-700/50 transition-colors">
        <Icon size={16} className={iconColor} />
        <h3 className="font-heading font-bold text-sm flex-1">{title}</h3>
        <ChevronDown size={16} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 pb-4 pt-1 border-t border-slate-700/60">{children}</div>}
    </div>
  );
}
